export class CurrencyLocale {
  constructor(data: {
    currencySymbol: string;
    decimalSeparator: string;
    groupSeparator: string;
  }) {
    this.currencySymbol = data.currencySymbol;
    this.decimalSeparator = data.decimalSeparator;
    this.groupSeparator = data.groupSeparator;

    const currencySymbol = this.currencySymbol.trim();
    if (currencySymbol === "₹") {
      this.thousandsGroupStyle = "lakh";
    } else {
      this.thousandsGroupStyle = undefined;
    }
  }

  static default = new CurrencyLocale({
    currencySymbol: "$",
    decimalSeparator: ".",
    groupSeparator: ",",
  });

  currencySymbol: string;
  decimalSeparator: string;
  thousandsGroupStyle: undefined | "lakh" | "wan";
  groupSeparator: string;
}
